exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".information-modal {\n  width: 100%;\n  height: 100%;\n}", ""]);

